export const formatNotificationCount = count => {
  const value = Number(count);
  if (!Number.isFinite(value) || value <= 0) {
    return '';
  }

  if (value > 99) {
    return '99+';
  }

  return String(value);
};
